import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import CodesTab from '@/views/CodesTab.vue'
import TransactionsTab from '@/views/TransactionsTab.vue'
import SettingsTab from '@/views/SettingsTab.vue'
import Sidebar from '@/views/Sidebar.vue'
import {
  requireAuth,
  requireSTToken,
  requireSectionRights
} from '@/services/AuthService'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'home',
      path: '/',
      component: Home,
      beforeEnter: requireAuth,
      redirect: { name: 'codes' },
      children: [
        {
          name: 'codes',
          path: '/codes',
          components: {
            tab: CodesTab,
            sidebar: Sidebar
          },
          beforeEnter: requireSectionRights('codes'),
          props: {
            tab: { type: 'CODES' },
            sidebar: { type: 'CODES' }
          }
        }, {
          name: 'pending-transactions',
          path: '/pending-transactions',
          components: {
            tab: TransactionsTab,
            sidebar: Sidebar
          },
          beforeEnter: requireSectionRights('pending-transactions'),
          props: {
            tab: { type: 'PENDING_TRANSACTIONS' },
            sidebar: { type: 'PENDING_TRANSACTIONS' }
          }
        }, {
          name: 'completed-transactions',
          path: '/completed-transactions',
          components: {
            tab: TransactionsTab,
            sidebar: Sidebar
          },
          beforeEnter: requireSectionRights('completed-transactions'),
          props: {
            tab: { type: 'COMPLETED_TRANSACTIONS' },
            sidebar: { type: 'COMPLETED_TRANSACTIONS' }
          }
        }, {
          name: 'settings',
          path: '/settings',
          beforeEnter: requireSectionRights('settings'),
          components: {
            tab: SettingsTab,
            sidebar: Sidebar
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    }
  ],
  mode: 'history'
})

function operate (guards, from, to, lastNext, i) {
  let guard = guards[i]
  if (guards.length === i + 1) {
    guard(from, to, lastNext)
  } else {
    guard(from, to, function (nextArg) {
      switch (typeof (nextArg)) {
        case 'undefined':
          operate(guards, from, to, lastNext, i + 1)
          break
        case 'object':
          lastNext(nextArg)
          break
        case 'boolean':
          lastNext(nextArg)
          break
        case 'string':
          lastNext(nextArg)
          break
      }
    })
  }
}

function allGuards (listOfGuards) {
  return function (from, to, next) {
    operate(listOfGuards, from, to, next, 0)
  }
}
